"use client";

import { useState, useEffect } from 'react';
import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";
import { formatDistanceToNow, isPast } from "date-fns";

export function RaffleCountdown({ endDate }: { endDate: Date | null }) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!endDate || !isClient) {
     return (
      <Badge variant="destructive" className="font-semibold">
        <Clock className="h-3 w-3 mr-1" />
        Loading...
      </Badge>
    );
  }

  if (isPast(endDate)) {
    return (
      <Badge variant="destructive" className="font-semibold">
        <Clock className="h-3 w-3 mr-1" />
        Ended
      </Badge>
    );
  }
  
  return (
    <Badge variant="default" className="font-semibold bg-gradient-to-r from-blue-500 to-purple-500">
      <Clock className="h-3 w-3 mr-1" />
      {formatDistanceToNow(endDate, { addSuffix: true })}
    </Badge>
  );
}
